import React, { useState, useRef, useCallback, useEffect } from 'react';
import PermButton from '../../core/utils/PermButton';
import { useSelector, useDispatch } from 'react-redux';
import { selectFilteredCarriers, selectCarrierLoading } from './store/selectors';
import VirtualList from '../components/VirtualList';
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner';
import { isHeaderVisible } from 'Core/redux/main/selectors';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import { showModal } from 'Core/redux/main/slice';
import { Edit } from 'react-feather';
import { Button, ButtonGroup } from 'react-bootstrap';
import { fetchCarrierById } from './store/slice';

const { CARRIERS_ADD_EDIT } = MODAL_TYPES;

const CarrierTile = () => {
  const [columnCount, setColumnCount] = useState(6);
  const [columnWidth, setColumnWidth] = useState(300);
  const carrierTileRef = useRef(null);
  const filteredCarriers = useSelector(selectFilteredCarriers);
  const isLoading = useSelector(selectCarrierLoading);
  const headerVisible = useSelector(isHeaderVisible);

  const updateColumnSettings = useCallback(() => {
    if (carrierTileRef.current) {
      const width = carrierTileRef.current.offsetWidth;
      let columns = 6;

      if (width < 576) columns = 1;
      else if (width < 768) columns = 3;
      else if (width < 992) columns = 5;
      else columns = 6;

      setColumnCount(columns);
      setColumnWidth(width / columns);
    }
  }, []);

  useEffect(() => {
    updateColumnSettings();
    window.addEventListener('resize', updateColumnSettings);
    return () => window.removeEventListener('resize', updateColumnSettings);
  }, [updateColumnSettings]);

  const itemData = filteredCarriers.map(carrier => <Tile carrier={carrier} key={carrier.id} />);

  return (
    <div
      className={`shipment-tile-body ${!headerVisible ? 'header-collapsed' : ''}`}
      ref={carrierTileRef}
    >
      {isLoading && <LoadingSpinner />}
      <VirtualList
        columnCount={columnCount}
        rowCount={Math.ceil(filteredCarriers.length / columnCount)}
        itemData={itemData}
        columnWidth={columnWidth}
        rowHeight={180}
      />
    </div>
  );
};

const Tile = ({ carrier }) => {
  const dispatch = useDispatch();

  const handleEdit = async e => {
    e.stopPropagation();
    const id = carrier?.id;
    if (!id) return;
    const result = await dispatch(fetchCarrierById(id));
    const payload = result?.payload;
    if (result?.type?.endsWith('/fulfilled')) {
      dispatch(showModal(CARRIERS_ADD_EDIT, payload));
    }
  };

  return (
    <div className="shipment-tile ellipsis-tile">
      <div
        className="card p-3 m-2"
        style={{
          border: '1px solid #ddd',
          borderRadius: '4px',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        }}
      >
        <div className="tile-actions">
          <ButtonGroup size="sm">
            <PermButton perm="MASTERS.CARRIER.EDIT">
              <Button variant="light" onClick={handleEdit}>
                <Edit size={16} />
              </Button>
            </PermButton>
          </ButtonGroup>
        </div>

        <div className="d-flex justify-content-between">
          <div className="d-flex flex-row align-items-center">
            <div className="ms-2 c-details">
              <h6 className="mb-1 truncate-2lines" title={carrier.carrierName}>
                {carrier.carrierName}
              </h6>
              <div className="mb-1">
                <span className="text-dark fw-medium">{carrier.carrierShortName || '--'}</span>
              </div>
              <div className="mb-2">
                <span className="text-dark fw-medium">{carrier.label || '--'}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="ms-2">
          <div className="mt-1">
            <span
              className="badge"
              style={{
                backgroundColor: carrier.backGroundColor || '#e0e0e0',
                color: carrier.textColor || '#000000',
              }}
            >
              {carrier.status || 'N/A'}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarrierTile;

